import VerifyCode from './VerifyCode'

/* istanbul ignore next */
VerifyCode.install = function (Vue) {
  Vue.component('verify-code', VerifyCode)
}

export default VerifyCode



// WEBPACK FOOTER //
// ./src/components/verify-code/index.js